<template>
  <b-col
    class="next-payment-container d-flex flex-column big-rounded"
    ref="next-payment"
  >
    <b-row
      class="payment-status-title flex-grow-1 align-items-center py-2 my-2"
      v-if="hasPayment"
    >
      <b-col
        id="popover-help"
        cols="12"
        md="12"
        lg="12"
        class="mb-3 text-center"
      >
        <p class="text-next-payment m-0 p-0 text-center">
          {{ currentTitlePaymentStatus }}
          <span class="payment-help-info" v-if="!checkMobile(576)">
            <img class="icon-tooltip" src="@/assets/icons/tooltip.svg" />
          </span>
        </p>
      </b-col>
      <b-col cols="12" md="12" lg="12">
        <b-container class="payment-information">
          <b-row class="d-flex position-relative align-items-center">
            <b-toast
              id="payment-toast"
              class="payment-toast position-absolute"
              static
              no-close-button
              no-auto-hide
            >
              <b-container class="p-0">
                <b-row>
                  <b-col class="d-flex align-items-start">
                    <img src="@/assets/information_big.svg" class="mr-3" />
                    <div class="waiting-payment">
                      <h6>Pagamento em liberação</h6>
                      <p>
                        Leva até 4 dias úteis para cair na sua conta.
                        <a href="#">Saiba mais</a>
                      </p>
                    </div>
                    <div class="estimated-payment">
                      <h6>O valor do pagamento está em processamento</h6>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </b-toast>
            <b-tabs
              class="tab-payment mt-4"
              active-nav-item-class="activeTab"
              active-tab-class="tab-content-active-class"
              justified
            >
              <b-tab
                v-for="(payment, index) of currentBalanceObject"
                :key="index"
                :title="payment.expected_to | abbreviateDate"
                :active="index === 0"
                class="p-3"
                @click="changePeriod(index)"
                title-link-class="activeTabInactive"
              >
                <p class="total-value-payment mb-0">
                  <b-row>
                    <b-col cols="8">
                      <div id="payment-value">
                        <span>R$</span
                        ><span :id="'total' + index" :ref="'total' + index">
                          {{ payment.value | numberToCurrency }}
                          <span v-show="hasCpf">*</span>
                        </span>
                      </div>
                    </b-col>
                    <b-col cols="4">
                      <span
                        class="tag-payment-type"
                        :id="'tag-enviado' + index"
                        v-if="payment.status === 'VP'"
                      >
                        <img class="icon-tag" src="@/assets/icons/check.svg" />
                        Enviado
                      </span>
                      <span
                        class="tag-payment-type"
                        :id="'tag-estimado' + index"
                        v-else-if="payment.is_estimated == 1"
                      >
                        <img
                          class="icon-tag"
                          src="@/assets/icons/estimated.svg"
                        />
                        Estimado
                      </span>
                      <span
                        class="tag-payment-type"
                        :id="'tag-agendado' + index"
                        v-else
                      >
                        <img
                          class="icon-tag"
                          src="@/assets/icons/scheduled.svg"
                        />
                        Agendado
                      </span>
                      <b-popover
                        :target="'tag-enviado' + index"
                        triggers="hover"
                        placement="top"
                      >
                        <div class="popover-text">
                          <p>Status: Enviado para o Banco</p>
                          Pagamento em liberação. Leva até 4 dias úteis para
                          cair na sua conta.
                        </div>
                      </b-popover>

                      <b-popover
                        :target="'tag-estimado' + index"
                        triggers="hover"
                        placement="top"
                      >
                        <div class="popover-text">
                          <p>Status: Estimado</p>
                          Este é o valor calculado e em breve será agendado o
                          pagamento.
                        </div>
                      </b-popover>

                      <b-popover
                        :target="'tag-agendado' + index"
                        triggers="hover"
                        placement="top"
                      >
                        <div class="popover-text">
                          <p>Status: Agendado</p>
                          Esse valor foi fechado e o pagamento já está agendado.
                        </div>
                      </b-popover>
                    </b-col>
                  </b-row>
                </p>
              </b-tab>
            </b-tabs>
          </b-row>
        </b-container>
      </b-col>
      <b-col>
        <p class="text-next-payment mb-1 p-0 text-center">
          RELATIVO AO PERÍODO:
          <span :class="['period m-0 p-0 text-center']">
            {{ getPeriod.from | abbreviateDate }}
            -
            {{ getPeriod.to | abbreviateDate }}
          </span>
        </p>
        <p class="text-irrf mt-1 mb-0 p-0 text-center" v-show="hasCpf">
          <span>*Valor sujeito a incidência de IRRF</span>
        </p>
      </b-col>

      <b-popover target="popover-help" triggers="hover" placement="top">
        <div class="popover-text">
          <p>
            Aqui estão os valores estimados e agendados referentes a períodos
            passados. As informações do período atual não aparecem aqui pois
            ainda estão em aberto.
          </p>
        </div>
      </b-popover>
    </b-row>
  </b-col>
</template>
<script>
import { mapGetters } from 'vuex';
import { numberToCurrency } from '@/utils/currencyUtils';
import { abbreviateDate } from '@/utils/dateUtils';
import filterPayments from '@/utils/filterUtils';

export default {
  name: 'NextPaymentV3',
  data() {
    return {
      activePeriod: 0,
    };
  },
  methods: {
    checkMobile(size) {
      return window.innerWidth <= size;
    },
    changePeriod(period) {
      this.activePeriod = period;

      setTimeout(() => {
        this.$refs[`total${period}`][0].click();
      }, 800);
    },
    getWindowSize() {
      return window.innerWidth;
    },
    showPopup(elClass) {
      this.$root.$emit('bv::hide::popover');
      this.$bvToast.show('payment-toast');

      setTimeout(() => {
        document.querySelector(`#payment-toast .${elClass}`).style.display = 'block';
      }, 100);

      const popoverListener = (ev) => {
        if (!document.getElementById('payment-toast').contains(ev.target)) {
          document
            .querySelector('.top-container')
            .removeEventListener('click', popoverListener);

          this.$bvToast.hide('payment-toast');
          this.$root.$emit('bv::show::popover');
        }
      };

      document
        .querySelector('.top-container')
        .addEventListener('click', popoverListener);
    },
  },
  computed: {
    ...mapGetters(['payments', 'currentBalance', 'affiliateInfo']),
    getPeriod() {
      const { period } = this.payments[this.activePeriod];
      return period;
    },
    currentBalanceObject() {
      return filterPayments(this.payments);
    },
    currentTitlePaymentStatus() {
      return this.currentBalanceObject.length > 1
        ? 'PRÓXIMOS PAGAMENTOS'
        : 'PRÓXIMO PAGAMENTO';
    },
    hasPayment() {
      return this.payments;
    },
    hasCpf() {
      if (this.affiliateInfo != null && this.affiliateInfo.numCpf) {
        return true;
      }

      return false;
    },
  },
  created() {
    if (window.innerWidth > 700) {
      setTimeout(() => {
        this.$refs.total0[0].click();
      }, 1000);
    }
  },
  filters: {
    abbreviateDate,
    numberToCurrency,
  },
};
</script>
<style lang="scss" scoped>
.next-payment-container {
  height: 100%;
  font-family: $font-1;
  background: url("~@/assets/dollar-sign.svg") 103% 110% no-repeat;
  background-color: #cb6c23;
  border: 1px solid $strong-orange;
  background-size: 100px 100px;
  padding: initial;

  @media screen and (max-width: $md) {
    background-position: 103% 104%;
  }
}

/* NextPayment */
.tab-payment {
  width: 100%;
}
.total-value-payment {
  font-size: $font-size-big;
  padding: 5px 10px;
  font-weight: bold;
  color: #ffffff;
  cursor: pointer;
  position: relative;
}

.period {
  color: #fff;
  font-family: UOLText;
  font-size: 18px;
  font-weight: bold;

  @media screen and (max-width: $md) {
    font-size: 18px;
    color: #fff;
    line-height: 1.2;
  }
}

.period-yellow {
  color: #ffe57f;
  font-family: UOLText;
  font-size: 18px;
  font-weight: bold;

  @media screen and (max-width: $md) {
    font-size: 18px;
    color: #ffe57f;
    line-height: 1.2;
  }
}

.row {
  padding: 0;
  margin: 0;
}

.payment-information {
  width: 80%;
  @media screen and (max-width: $sm) {
    width: 100%;
  }
}

.payment-toast {
  display: flex;
  margin-top: 9%;
  background: #fff;
  color: #000;
  z-index: 2;
}

.popover-title {
  font-size: 12px;
  text-transform: uppercase;
}

.estimated-payment,
.waiting-payment {
  display: none;
}

.text-next-payment {
  font-size: 18px;
  color: #fff;

  @media screen and (max-width: $md) {
    font-size: 18px;
    color: #fff;
    line-height: 1.2;
  }
}

.payment-status-title {
  z-index: 10;

  @media screen and (max-width: $md) {
    align-items: flex-start !important;
  }
}

.text-irrf {
  span {
    font-size: 14px;
    color: $text-light;
    opacity: 0.5;
  }
}

.text-info-new-rule {
  span {
    font-family: UOLText;
    font-size: 14px;
    color: #ffe57f;
    opacity: 1;
  }
}

.tag-payment-type {
  float: right;
  width: max-content;
  height: 32px;
  background: #b77039 0% 0% no-repeat padding-box;
  border-radius: 32px;
  padding-left: 8px;
  padding-top: 6px;
  padding-right: 12px;
  opacity: 1;
  font-family: UOLtext;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
}

.popover-text {
  font-family: UOLtext;
  font-size: 12px;
  color: #666666;
}

.payment-help-info {
  margin-left: 14px;
}

.a-popover-paymet {
  text-decoration: none;
  color: #0070ab;
}

.a-popover-paymet:hover {
  text-decoration: underline;
}

.icon-tag {
  width: 14px;
  height: 14px;
}

.icon-tooltip {
  position: absolute;
  top: 5px;
  width: 16px;
  height: 16px;
}

.owl-carousel .owl-item img {
  display: initial !important;
  width: auto !important;
}
</style>
